var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled from '@emotion/styled/macro';
import { Title } from './Title';
var Wrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-block;\n  vertical-align: top;\n  margin-right: 30px;\n"], ["\n  display: inline-block;\n  vertical-align: top;\n  margin-right: 30px;\n"])));
var SectionLayoutContainer = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n"], ["\n  display: flex;\n  flex-direction: column;\n"])));
var Components = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  & > div {\n    margin: 0px 8px 8px 0px;\n  }\n"], ["\n  display: flex;\n  flex-direction: row;\n  & > div {\n    margin: 0px 8px 8px 0px;\n  }\n"])));
export var SectionLayout = function (_a) {
    var children = _a.children, title = _a.title;
    return (React.createElement(Wrapper, null,
        React.createElement(SectionLayoutContainer, null,
            React.createElement(Title, null, title),
            React.createElement(Components, null, children))));
};
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=SectionLayout.js.map